import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { PathListItemModule } from '@portal-core/ui/list/components/path-list-item/path-list-item.module';
import { CollabConflictResolutionDialogComponent } from './collab-conflict-resolution-dialog.component';

@NgModule({
  declarations: [
    CollabConflictResolutionDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatTooltipModule,
    PathListItemModule,
    SelfTruncatingPathModule,
    RouterModule
  ],
  exports: [
    CollabConflictResolutionDialogComponent
  ]
})
export class CollabConflictResolutionDialogModule { }
